import React, { useCallback, useEffect, useRef } from "react";
import { TextField, makeStyles } from "@material-ui/core";

import { get } from "lodash";
import { useDataProvider } from "react-admin";
import { useDebounce } from "ra-friendsofbabba";

const useStyles = makeStyles((theme) => ({
  text: {
    minWidth: 200,
  },
}));
const RecordInput = ({
  record,
  source,
  type = "text",
  maxLength = undefined,
}) => {
  const classes = useStyles();
  const [value, setValue] = React.useState(get(record, source));
  const handleChange = useCallback((e) => setValue(e.target.value), []);
  const debouncedValue = useDebounce(value, 500);
  const dataProvider = useDataProvider();
  const didMount = useRef(false);
  useEffect(() => {
    setValue(get(record, source));
  }, [record, source]);
  useEffect(() => {
    if (!didMount.current) {
      didMount.current = true;
      return;
    }

    dataProvider.post("monitoring-experts/update", {
      id: record.id,
      [source]: debouncedValue,
    });
  }, [debouncedValue, dataProvider, record, source]);
  return (
    <TextField
      value={value}
      type={type}
      className={classes[type]}
      onChange={handleChange}
      inputProps={{ maxLength }}
    />
  );
};
export default RecordInput;
